export const unauthorizedProductsProProps = () => ({
  unauthorizedProducts: {
    type: Array,
    required: false,
    default: () => { return [] }
  }
})